import { render, staticRenderFns } from "./LightboxModal.vue?vue&type=template&id=a74bf05c&scoped=true"
import script from "./LightboxModal.vue?vue&type=script&lang=js"
export * from "./LightboxModal.vue?vue&type=script&lang=js"
import style0 from "./LightboxModal.vue?vue&type=style&index=0&id=a74bf05c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74bf05c",
  null
  
)

export default component.exports